import PropelIcon from '../../images/propel-icon-white.svg';

const drawerWidth = 256;

export const styles = theme => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  divider: {
    backgroundColor: 'rgba(255,255,255,.12)'
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap'
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    }),
    overflowX: 'hidden'
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    overflowX: 'hidden',
    'overflow-y': 'hidden',
    width: theme.spacing.unit * 7 + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9 + 1
    }
  },
  hidden: {
    display: 'none'
  },
  logoToolbar: {
    minHeight: '55px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  menuDefaultColor: {
    color: 'rgba(255,255,255,0.54)'
  },
  menuRow: {
    borderRadius: '4px',
    height: 40,
    marginBottom: theme.spacing.unit,
    paddingLeft: theme.spacing.unit * 2.5,
    paddingRight: theme.spacing.unit * 2.5
  },
  menuText: {
    fontFamily: 'Rubik',
    fontSize: '14px',
    fontWeight: 500,
    letterSpacing: '0.2px',
    lineHeight: '20px'
  },
  nav: {
    display: 'flex',
    flexFlow: 'column',
    height: '100%',
    'overflow-y': 'auto'
  },
  navContainer: {
    flex: '2 1 auto'
  },
  primaryNavRoot: {
    paddingLeft: theme.spacing.unit * 0.5,
    paddingRight: theme.spacing.unit * 0.5
  },
  primaryMenuActive: {
    borderRadius: '4px',
    '& .menuIcon,.menuText ': {
      color: '#FFFFFF'
    }
  },
  menuIcon: {
    minHeight: 24,
    minWidth: 24
  },
  primaryMenuText: {
    paddingLeft: theme.spacing.unit
  },
  secondaryMenuText: {
    paddingLeft: `${theme.spacing.unit * 6.125}px !important`
  },
  propelLogo: {
    flex: 1,
    marginLeft: theme.spacing.unit * 2,
    paddingTop: theme.spacing.unit * 2,
    width: 91
  },
  propelIcon: {
    height: '10px',
    margin: '0 auto',
    '& img': {
      maxWidth: '50px'
    }
  },
  secondaryNavContainer: {
    marginTop: '28px'
  },
  groupExpanded: {
    '& .menuIcon,.menuText ': {
      color: '#FFFFFF'
    }
  },
  poweredBy: {
    color: 'rgba(255,255,255,0.54)',
    fontSize: '16px',
    fontFamily: theme.typography.fontFamily,
    fontWeight: 'bold',
    lineHeight: '18px',
    letterSpacing: '0.2px',
    margin: '0 auto',
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 3,
    '& a': {
      'text-decoration': 'none',
      color: 'rgba(255,255,255,0.54)',
      '&:hover': {
        fontSize: '17px',
        'text-decoration': 'underline',
        cursor: 'pointer'
      }
    }
  },
  poweredByIcon: {
    backgroundImage: `url(${PropelIcon})`,
    height: '25px',
    width: '19px',
    margin: '0 auto',
    backgroundRepeat: 'no-repeat',
    marginBottom: theme.spacing.unit * 3
  }
});
